EBContext.modules.Analytics = function(){
	let self = this;
	let measureService = function(options){
		this.options = options;
		this.id = this.options.serviceId;
		Object.entries(this.options.events).forEach(e=>this[e[0]]=e[1]);
	};
	
	this.services = [];
	this.registerService = (options, extOptions)=>{
		EBContext.utils.extendObj(false, options, extOptions);
		options.serviceInit(options, options=>{if(!self.services.find(s=>s.id===options.serviceId)) self.services.push(new measureService(options))});
	};
	this.removeService = serviceId=>{
		self.services = self.services.filter(s=>s.options.serviceId!==serviceId);
	};
	this.init = ()=>{
		EBContext.ready(()=>self.getPageData());
		EBContext.await('EBContext_AjaxNavigation',()=>document.addEventListener('EBContext.ajaxNav.navigated',()=>self.getPageData()));
	};
	this.getPageData = ()=>{
		let eventsElms = document.querySelectorAll('[data-measure]');
		[...eventsElms].forEach(el=>{
			let dataEvents = el.getAttribute('data-measure').split(',');
			let dataElms = [...el.querySelectorAll('script[type="application/ld+json"]')];
			if(dataElms.length){
				let dataArr = [];
				dataElms.forEach(el2=>{
					let data;
					try {
						data = JSON.parse(el2.innerText);
					} catch (e) {
						console.error(e);
						data = {error: e};
					}
					dataArr.push(data);
				});
				dataEvents.forEach(e=>self.fire(e, dataArr));
			}
		});
	};
	this.tryGetItem = (objectClass, objectId)=>{
		let objEl = document.querySelector('script[data-object="'+objectClass+'.'+objectId+'"]');
		let objData = null;
		if(objEl){
			try {
				objData = JSON.parse(objEl.innerText);
			} catch (e) {
				console.error(e);
			}
		}
		return objData;
	};
	this.fire = (eventName, data)=>{
		if(data && (!Array.isArray(data) || !data.find(a=>!a))) self.services.forEach(s=>{
			if('function' === typeof s.options.eventsInit) s.options.eventsInit(data);
			if('function' === typeof s[eventName]) s[eventName](data, s.options);
		});
	};
	this.init();
	return this;
};
EBContext.analytics = new EBContext.modules.Analytics();

// *** Konfigurace jednotliv�ch m���c�ch slu�eb

// Google - GTM, GA4
EBContext.utils.setObj(EBContext, 'config.analytics.GA4', {
	serviceId: 'GA4',
	serviceInit: (options, callback) => {
		let condFn = callback=>{
			let consentStr = EBContext.session.cookie.get('allowCookies');
			
			// update consentu pro v�echny aplikace Google
			if('function' === typeof window.gtag && consentStr !== null){
				let consentArr = consentStr.split(',');
				let allowAll = (consentStr === '*');
				let reasonsArr = Object.keys(EBContext.session.cookie.reasons);
				gtag('consent', 'update', {
					ad_storage: (consentArr.indexOf('MARKETING') > -1 || (allowAll && reasonsArr.indexOf('MARKETING') > -1) ? 'granted' : 'denied'),
					ad_user_data: (consentArr.indexOf('MARKETING') > -1 || (allowAll && reasonsArr.indexOf('MARKETING') > -1) ? 'granted' : 'denied'),
					ad_personalization: (consentArr.indexOf('MARKETING') > -1 || (allowAll && reasonsArr.indexOf('MARKETING') > -1) ? 'granted' : 'denied'),
					analytics_storage: (consentArr.indexOf('ANALYTIC') > -1 || (allowAll && reasonsArr.indexOf('ANALYTIC') > -1) ? 'granted' : 'denied'),
					security_storage: (consentArr.indexOf('SYSTEM') > -1 || (allowAll && reasonsArr.indexOf('SYSTEM') > -1) ? 'granted' : 'denied'),
					functionality_storage: (consentArr.indexOf('SYSTEM') > -1 || (allowAll && reasonsArr.indexOf('SYSTEM') > -1) ? 'granted' : 'denied'),
					personalization_storage: (consentArr.indexOf('PREFERENCE') > -1 || (allowAll && reasonsArr.indexOf('PREFERENCE') > -1) ? 'granted' : 'denied')
				});
			}
            callback(options);
		};
		// rovnou zinicializovat
		condFn(callback);
		
		// nastavit inicializaci i na event listener na zm�nu consentu
		document.addEventListener('EBContext.session.setConsent', e=>{condFn(callback);return true});
	},
	events: {
		view_item_list: (data, opt) => {
			// pasivn� event - vyt�hnout data ze str�nky
			let products = data.filter((d) => d && d['@type'] === 'Product');
			let eventData = data.filter((d) => d && d['@type'] === 'Action');
			if (eventData && eventData.length) eventData = eventData[0];
			dataLayer.push({ ecommerce: null });
			let dlObj = { event: 'view_item_list', ecommerce: { item_list_id: eventData.id, item_list_name: eventData.name, items: opt.goodsParser(products, eventData) } };
			dataLayer.push(dlObj);
			console.trace('Analytic', dlObj);
		},
		view_item: (data, opt) => {
			// pasivn� event - vyt�hnout data ze str�nky
			let products = data.filter((d) => d && d['@type'] === 'Product');
			let eventData = data.filter((d) => d && d['@type'] === 'Action');
			if (eventData && eventData.length) eventData = eventData[0];
			dataLayer.push({ ecommerce: null });
			let items = opt.goodsParser(products, eventData);
			let dlObj = { event: 'view_item', ecommerce: { currency: EBContext.data.session.Cust_Mena, value: items[0].price*items[0].quantity,items: items } };
			dataLayer.push(dlObj);
			console.trace('Analytic', dlObj);
		},
		add_to_cart: (data, opt) => {
			// aktivn� event volan� z EBContext.session.basket. Data se budou p�ed�vat.
			dataLayer.push({ ecommerce: null });
			let items = opt.basketParser(data);
			let dlObj = { event: 'add_to_cart', ecommerce: { currency: EBContext.data.session.Cust_Mena, value: items.reduce((a,c)=>a+=c.price*c.quantity, 0), items: items  } };
			dataLayer.push(dlObj);
			console.trace('Analytic', dlObj);
		},
		remove_from_cart: (data, opt) => {
			// aktivn� event volan� z EBContext.session.basket. Data se budou p�ed�vat.
			dataLayer.push({ ecommerce: null });
			let items = opt.basketParser(data);
			let dlObj = { event: 'remove_from_cart', ecommerce: { currency: EBContext.data.session.Cust_Mena, value: items.reduce((a,c)=>a+=c.price*c.quantity, 0), items: items  } };
			dataLayer.push(dlObj);
			console.trace('Analytic', dlObj);
		},
		update_shopping_cart: (data, opt) => {
			// aktivn� event volan� z EBContext.session.basket. Data se budou p�ed�vat.
			let addItems = data.filter(item=>(item.responseItem.amount > item.oldItem.Amount)).map(item=>{item.responseItem.changeAmount=item.responseItem.amount-item.oldItem.Amount; return item}),
				rmItems = data.filter(item=>(item.responseItem.amount < item.oldItem.Amount)).map(item=>{item.responseItem.changeAmount=item.oldItem.Amount-item.responseItem.amount; return item}),
				updateItems = data.filter(item=>(undefined === item.responseItem.amount || item.responseItem.amount === item.oldItem.Amount));
			
			if(addItems.length) opt.events.add_to_cart(addItems, opt);
			if(rmItems.length) opt.events.remove_from_cart(rmItems, opt);
			if(updateItems.length){
				dataLayer.push({ ecommerce: null });
				let items = opt.basketParser(updateItems);
				let dlObj = { event: 'update_shopping_cart', ecommerce: { currency: EBContext.data.session.Cust_Mena, value: items.reduce((a,c)=>a+=c.price*c.quantity, 0), items: items } };
				dataLayer.push(dlObj);
				console.trace('Analytic', dlObj);
			}
		},
		empty_shopping_cart: (data, opt) => {
			// aktivn� event volan� z EBContext.session.basket. Data se budou p�ed�vat.
			dataLayer.push({ ecommerce: null });
			let items = opt.basketParser(data);
			let dlObj = { event: 'empty_shopping_cart', ecommerce: { currency: EBContext.data.session.Cust_Mena, value: items.reduce((a,c)=>a+=c.price*c.quantity, 0), items: items  } };
			dataLayer.push(dlObj);
			console.trace('Analytic', dlObj);
		},
		save_shopping_cart: (data, opt) => {
			// aktivn� event volan� z EBContext.session.basket. Data se budou p�ed�vat.
			dataLayer.push({ ecommerce: null });
			let items = opt.basketParser(data.items);
			let dlObj = { event: 'save_shopping_cart', ecommerce: { currency: EBContext.data.session.Cust_Mena, value: items.reduce((a,c)=>a+=c.price*c.quantity, 0), cart_id: data.response, cart_name: data.name, items: items } };
			dataLayer.push(dlObj);
			console.trace('Analytic', dlObj);
		},
		delete_shopping_cart: (data, opt) => {
			// aktivn� event volan� z EBContext.session.basket. Data se budou p�ed�vat.
			dataLayer.push({ ecommerce: null });
			let dlObj = { event: 'delete_shopping_cart', ecommerce: { cart_id: data.oid} };
			dataLayer.push(dlObj);
			console.trace('Analytic', dlObj);
		},
		view_cart: (data, opt) => {
			// pasivn� event - vyt�hnout data ze str�nky
			let products = data.filter((d) => d && d['@type'] === 'Product');
			let eventData = data.filter((d) => d && d['@type'] === 'Action' && d.identifier === 'view_cart');
			if (eventData && eventData.length) eventData = eventData[0];
			dataLayer.push({ ecommerce: null });
			let dlObj = {
				event: 'view_cart',
				ecommerce: {
					currency: eventData.currency,
					value: eventData.total,
					items: opt.goodsParser(products, eventData),
				}
			};
			if(false){ // p�i reloadu str�nky nejsou data o polo�k�ch ko��ku je�t� k dispozici - @TODO
				debugger;
				let items = opt.basketParser(EBContext.session.basket.items.map(item=>{ return {basketItem: item} }));
				dlObj.ecommerce = { currency: EBContext.data.session.Cust_Mena, value: items.reduce((a,c)=>a+=c.price*c.quantity, 0), items: items };
			}
			dataLayer.push(dlObj);
			console.trace('Analytic', dlObj);
		},
		begin_checkout: (data, opt) => {
			// pasivn� event - vyt�hnout data ze str�nky
			let products = data.filter((d) => d && d['@type'] === 'Product');
			let eventData = data.filter((d) => d && d['@type'] === 'Action' && d.identifier === 'begin_checkout');
			if (eventData && eventData.length) eventData = eventData[0];
			dataLayer.push({ ecommerce: null });
			let dlObj = {
				event: 'begin_checkout',
				ecommerce: {
					currency: eventData.currency,
					value: eventData.total,
					items: opt.goodsParser(products, eventData),
				}
			};
			dataLayer.push(dlObj);
			console.trace('Analytic', dlObj);
		},
		cart_summary: (data, opt) => {
			// pasivn� event - vyt�hnout data ze str�nky
			let products = data.filter((d) => d && d['@type'] === 'Product');
			let eventData = data.filter((d) => d && d['@type'] === 'Action' && d.identifier === 'cart_summary');
			if (eventData && eventData.length) eventData = eventData[0];
			dataLayer.push({ ecommerce: null });
			let dlObj = {
				event: 'cart_summary',
				ecommerce: {
					currency: eventData.currency,
					value: eventData.total,
					shipping_id: eventData.shipping_type,
					payment_id: eventData.payment_type,
					items: opt.goodsParser(products, eventData),
				}
			};
			dataLayer.push(dlObj);
			console.trace('Analytic', dlObj);
		},
		purchase: (data, opt) => {
			// pasivn� event - vyt�hnout data ze str�nky
			let products = data.filter((d) => d && d['@type'] === 'Product');
			let eventData = data.filter((d) => d && d['@type'] === 'Action' && d.identifier === 'purchase');
			if (eventData && eventData.length) eventData = eventData[0];
			dataLayer.push({ ecommerce: null });
			let dlObj = {
				event: 'purchase',
				ecommerce: {
					currency: eventData.currency,
					value: eventData.total,
					shipping_id: eventData.shipping_type,
					payment_id: eventData.payment_type,
					transaction_id: eventData.order_number,
					coupon: eventData.coupon,
					items: opt.goodsParser(products, eventData),
				}
			};
			dataLayer.push(dlObj);
			console.trace('Analytic', dlObj);
		},
		page_view_interaction: (data, opt) => {
			let dlObj = {
				event: 'page_view_interaction'
			};
			dataLayer.push(dlObj);
			console.trace('Analytic', dlObj);
		}
	},
	eventsInit: () => {
		if ('undefined' === typeof dataLayer) window.dataLayer = [];
	},
	goodsParser: (schemaItems, commonData)=>{
		if (!Array.isArray(schemaItems)) schemaItems = [schemaItems];
		commonData = commonData || {};
		let parsedItems = [];
		let i;
		for(i=0;i<schemaItems.length;i++){
			let item = schemaItems[i];
			item.offers = item.offers || {};
			let parsedItem = {
				item_id: item['@id'],
				item_name: item.name,
				index: i,
				currency: item.offers.priceCurrency,
				price: item.offers['@priceWithoutVAT'], //EBContext.utils.searchObj(item, 'offers.priceSpecification.price') || EBContext.utils.searchObj(item, 'offers.price'),
				quantity: [item['@quantity'], item.offers['@quantity'], 1].find(i=>i!==undefined)
			};
			if(i && item.brand) parsedItem.item_brand = item.brand.name;
			if(commonData.name) item_list_name = commonData.name;
			if(commonData.affiliation) parsedItem.affiliation = commonData.affiliation;
			parsedItems.push(parsedItem);
		}
		return parsedItems;
	},
	basketParser: (basketItems)=>{
		if (!Array.isArray(basketItems)) basketItems = [basketItems];
		let parsedItems = [];
		let i;
		for(i=0;i<basketItems.length;i++){
			let basketItem = basketItems[i].basketItem || basketItems[i].dumpItem || {}, jsonItem = basketItems[i].jsonItem || {}, responseItem = basketItems[i].responseItem || {}, oldItem = basketItems[i].oldItem || {};
			let parsedItem = {
				item_id: [responseItem.oid,basketItem.Good,jsonItem['@id'],oldItem.Good].find(a=>undefined !== a),
				item_name: [responseItem.name,basketItem.Name,jsonItem.name,oldItem.Name].find(a=>undefined !== a),
				currency: [jsonItem.priceCurrency,EBContext.data.session.Cust_Mena].find(a=>undefined !== a),
				price: EBContext.utils.parseMoney([basketItem.PriceUnit,EBContext.utils.searchObj(jsonItem, 'offers.@priceWithoutVAT'),oldItem.PriceUnit].find(a=>[undefined,null].indexOf(a)===-1)),
				quantity: [responseItem.changeAmount, responseItem.amount, basketItem.Amount].find(a=>[undefined,null].indexOf(a)===-1)
			};
			let comment = [responseItem.comment, basketItem.Comment].find(a=>[undefined,null].indexOf(a)===-1);
			if(undefined !== comment) parsedItem.comment = comment;
			parsedItems.push(parsedItem);
		}
		return parsedItems;
	}
});

// Zbo��.cz - "Omezen� m��en� konverz�"
EBContext.utils.setObj(EBContext, 'config.analytics.ZCZL', {
	serviceId: 'ZCZL', // ZboziCZ - Limited
	serviceInit: (options, callback)=>callback(options),
	events: {
		purchase: (data, opt) => {
			let eventData = data.filter((d) => d && d['@type'] === 'Action' && d.identifier === 'purchase');
			if (eventData && eventData.length) eventData = eventData[0];
			if(eventData && eventData.order_number && window.rc && window.rc.conversionHit){
				let consentStr = (EBContext.session.cookie.get('allowCookies') || '');
				let consentArr = consentStr.split(',');
				let allowAll = (consentStr === '*');
				let conversionConf = {
					orderId: eventData.order_number,
					value: eventData.total_CZK,
					consent: (consentArr.indexOf('MARKETING') > -1 || allowAll ? 1 : 0),
					zboziId: opt.zboziId,
					zboziType: 'limited'
				};
				console.debug('Konverze Zbo��.cz: ', conversionConf);
				window.rc.conversionHit(conversionConf);
			} else {
				console.error('"purchase" event data not found!');
			}
		}
	}
});

// Heureka.cz - "M��en� konverz�"
EBContext.utils.setObj(EBContext, 'config.analytics.HCZ', {
	serviceId: 'HCZ', // HeurekaCZ
	serviceInit: (options, callback)=>callback(options),
	events: {
		purchase: (data, opt) => {
			let products = data.filter((d) => d && d['@type'] === 'Product');
			let eventData = data.filter((d) => d && d['@type'] === 'Action' && d.identifier === 'purchase');
			if (eventData && eventData.length) eventData = eventData[0];
			
			window._hrq = window._hrq || [];
		    window._hrq.push(['setKey', opt.publicKey]);
		    window._hrq.push(['setOrderId', eventData.order_number]);
		    products.forEach(p=>{
			    window._hrq.push(['addProduct', p.name, p.offers.price.toString(), p.offers.eligibleQuantity.toString().split(' ')[0], p['@id']]);
		    });
		    window._hrq.push(['trackOrder']);
		    console.debug('Konverze Heureka.cz: ', window._hrq);
		    (function() {
			    var ho = document.createElement('script');
			    ho.type = 'text/javascript';
			    ho.async = true;
			    ho.src = 'https://im9.cz/js/ext/1-roi-async.js';
			    var s = document.getElementsByTagName('script')[0]; 
			    s.parentNode.insertBefore(ho, s);
			})();
		}
	}
});